import script from "./NEW_CURRENT_GOAL.vue?vue&type=script&lang=ts&setup=true"
export * from "./NEW_CURRENT_GOAL.vue?vue&type=script&lang=ts&setup=true"

import "./NEW_CURRENT_GOAL.vue?vue&type=style&index=0&id=757538f2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-757538f2"]])

export default __exports__